import {getPaymentOptionDisabledStatuses, getPaymentOptionHiddenStatuses} from './PaymentOptionDisabledSelectors';

export default (state) => {
  const optionDisabledStatuses = getPaymentOptionDisabledStatuses(state);
  const optionHiddenStatuses = getPaymentOptionHiddenStatuses(state);
  
  const availablePaymentOptionArray = optionDisabledStatuses.map((bool, index) => !bool && !optionHiddenStatuses[index]);
  return availablePaymentOptionArray.indexOf(true);
};
